// Maps a normalised API error ({ status, key }, see api/ackApi.js) to the i18n message the page shows.
// Every back-hia refusal of the acknowledgement flow has its own message; no HTTP code nor technical key is shown.

// back-hia keys are dotted (`ack.key.session.expired`); some relays use the enum name (`ack_key_not_found`).
export const normalizeKey = (key) => (typeof key === 'string' ? key.trim().toLowerCase().replace(/_/g, '.') : '');

const START_MESSAGES = Object.freeze({
    'ack.key.not.found': 'conventionPage.error.notFound',
    'ack.key.used': 'conventionPage.error.used',
    'ack.key.expired': 'conventionPage.error.linkExpired',
    'ack.key.session.expired': 'conventionPage.error.sessionExpired',
    'hia.invalid.convention.status': 'conventionPage.error.notPending',
    'hia.account.not.open': 'conventionPage.error.accountNotOpen',
    'hia.account.not.found': 'conventionPage.error.accountNotOpen',
});

const SESSION_KEYS = Object.freeze(['ack.key.session.expired', 'ack.key.expired']);

// The ack session is over: the page switches to its "session expired" state and makes no further call.
export const isSessionExpiry = (error) => !!error && SESSION_KEYS.indexOf(normalizeKey(error.key)) !== -1;

// Message of a failed ack-start (the page cannot be shown).
export const startErrorMessageId = (error) => {
    const id = error && START_MESSAGES[normalizeKey(error.key)];
    if (id) return id;
    if (error && error.status === 404) return 'conventionPage.error.notFound';
    return 'conventionPage.error.generic';
};

// Message of a failed validation (PUT ack) that is not a session expiry: dedicated when back-hia says why.
export const validationErrorMessageId = (error) => {
    const key = normalizeKey(error && error.key);
    if (key === 'hia.invalid.convention.status') return 'conventionPage.error.notPending';
    if (key === 'hia.account.not.open' || key === 'hia.account.not.found') return 'conventionPage.error.accountNotOpen';
    if (key === 'ack.key.not.found') return 'conventionPage.error.notFound';
    return 'conventionPage.validate.error';
};

export const PRACTICE_ERRORS = Object.freeze({
    SESSION: 'SESSION',
    CHALLENGE_EXPIRED: 'CHALLENGE_EXPIRED',
    TOO_MANY: 'TOO_MANY',
    UNAVAILABLE: 'UNAVAILABLE',
});

// Kind of a failed practice / check call (the validation always stays available).
export const practiceErrorKind = (error) => {
    if (isSessionExpiry(error)) return PRACTICE_ERRORS.SESSION;
    if (error && error.status === 410) return PRACTICE_ERRORS.CHALLENGE_EXPIRED;
    if (error && error.status === 429) return PRACTICE_ERRORS.TOO_MANY;
    return PRACTICE_ERRORS.UNAVAILABLE;
};
